import cssVars from "css-vars-ponyfill";
import { of } from "rxjs";
import { map } from "rxjs/operators";
import * as i0 from "@angular/core";
import * as i1 from "./theme.proxy";
/**
 ****************************************************************
 * Service class theme management.
 *
 * Created by Shai Zelman on 06/06/2020.
 ****************************************************************
 */
var ThemeService = /** @class */ (function () {
    function ThemeService(themeProxy) {
        this.themeProxy = themeProxy;
        this.initialized = false;
    }
    ThemeService.prototype.getTheme = function () {
        var _this = this;
        if (this.initialized) {
            return of(null);
        }
        return this.themeProxy.getTheme().pipe(map(function (variables) {
            cssVars({
                variables: variables,
                watch: true,
                include: "style"
            });
            _this.initialized = true;
        }));
    };
    ThemeService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ThemeService_Factory() { return new ThemeService(i0.ɵɵinject(i1.ThemeProxy)); }, token: ThemeService, providedIn: "root" });
    return ThemeService;
}());
export { ThemeService };
